export default {
  fb_pixel_id: "",
  google_site_verification: "",
  hotjar_id: "",
  ga_project_id: "",
  fb_site_verification: ""
}